import { useEffect, useState } from "react";

import { SigninResponse } from "../../interfaces";
import { useSelector } from "react-redux";
import { getLoggedInUserSession } from "../../services";

const useSession = () => {
  const userSession = getLoggedInUserSession();
  let token: string = userSession && userSession["token"];
  const [loading, setLoading] = useState(userSession ? false : true);
  const [session, setSession] = useState<SigninResponse>(
    userSession ? userSession : null,
  );

  const isAuthenticated = useSelector(
    (state: any) => state.auth?.isAuthenticated ?? false,
  );

  useEffect(() => {
    const userSession = getLoggedInUserSession();
    const nextToken = userSession && userSession["token"];
    setSession(userSession ? userSession : null);
    setLoading(nextToken ? false : true);
  }, [isAuthenticated]);

  return { session, loading, token };
};

export { useSession };
